import { TableAction } from "../../../../components/ModularDataTable"
import { i18n } from "../../../../translate/i18n"



type ActionsFactoryParams = {
  navigate: (path: string) => void
  showDeleteModal: (title: string) => void
  setDeleteId: (id: number) => void
  isSubCategory?: boolean
}

export function createActions({
  navigate,
  showDeleteModal,
  setDeleteId,
  isSubCategory
}: ActionsFactoryParams): TableAction[] {
  const editLabel = `${i18n.t(`general.edit`)}`
  const deleteLabel = `${i18n.t(`general.delete`)}`

  const route = isSubCategory ? '/agregador/subcategory/editar/' : '/agregador/category/editar/'

  const actions: TableAction[] = [
    {
      icon: 'fas fa-pen',
      label: editLabel,
      action: (item: any) => navigate(`${route}${item.id}`),
    },
    {
      icon: 'fas fa-trash',
      label: deleteLabel,
      action: (item: any) => {
        showDeleteModal(deleteLabel)
        setDeleteId(item.id)
      },
    }
  ]


  return actions
}

